import Service from '../../service'
import { apiOff } from '@/plugins/axios'

/**
 * @type {ApiOff}
 */
export default class ApiOff extends Service {

    constructor (options = {}) {
        super(options)
        this.http = apiOff
    }
}